module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "Introduction"
    }
  }), _vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What Is an Idea?")]), _vm._v(" "), _c('p', {
    staticClass: "centert"
  }, [_vm._v("I know the answer. The answer lies within the heart of all mankind! What, the answer is twelve? I think I’m in the wrong building.")]), _vm._v(" "), _c('p', {
    staticClass: "attribute1"
  }, [_c('em', [_vm._v("Charles Schultz")])]), _vm._v(" "), _c('p', {
    staticClass: "centert"
  }, [_vm._v("I was gratified to be able to answer promptly, and I did. I said I didn’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "attribute1"
  }, [_c('em', [_vm._v("Mark Twain")])]), _vm._v(" "), _c('p', {
    staticClass: "centert"
  }, [_vm._v("If love is the answer, could you please rephrase the question?")]), _vm._v(" "), _c('p', {
    staticClass: "attribute1"
  }, [_c('em', [_vm._v("Lily Tomlin")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("Before we figure out how to get ideas we must discuss what ideas are, for if we don’t know what things are it’s difficult to figure out how to get more of them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The only trouble is: How do you define an idea?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A. E. Housman said: “I could no more define poetry than a terrier can define a rat, but both of us recognize the object by the symptoms which it produces in us.” Beauty is like that too. So are things like quality and love.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And so, of course, is an idea. When we’re in the presence of one we know it, we feel it; something inside us recognizes it. But just try to define one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Look in dictionaries and you’ll find everything from: “That which exists in the mind, potentially or actually, as a product of mental activity, such as a thought or knowledge,” to “The highest category: the complete and final product of reason,” to “A transcendent entity that is a real pattern of which existing things are imperfect representations.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A lot of good that does you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The difficulty is stated perfectly by Marvin Minsky in "), _c('em', [_vm._v("The Society of Mind:")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("Only in logic and mathematics do definitions"), _c('br'), _vm._v("ever capture concepts perfectly. … You can"), _c('br'), _vm._v("know what a tiger is without defining it. You"), _c('br'), _vm._v("may define a tiger, yet know scarcely anything"), _c('br'), _vm._v("about it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you ask people for a definition, however, you get better answers, answers that come pretty close to capturing both the concept and the thing itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here are some answers I got from my coworkers and from my students at the University of Southern California and the University of California at Los Angeles:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_vm._v("It’s something that’s so obvious that after"), _c('br'), _vm._v("someone tells you about it you wonder why you"), _c('br'), _vm._v("didn’t think of it yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_vm._v("An idea encompasses all aspects of a situation"), _c('br'), _vm._v("and makes it simple. It ties up all the loose ends"), _c('br'), _vm._v("into one neat knot. That knot is called an idea.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_vm._v("It is an immediately understood representation"), _c('br'), _vm._v("of something universally known or accepted,"), _c('br'), _vm._v("but conveyed in a novel, unique, or unexpected"), _c('br'), _vm._v("way.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_vm._v("Something new that can’t be seen from what"), _c('br'), _vm._v("preceded it.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("It’s that flash of insight that lets you see things"), _c('br'), _vm._v("in a new light, that unites two seemingly"), _c('br'), _vm._v("disparate thoughts into one new concept.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_vm._v("An idea synthesizes the complex into the"), _c('br'), _vm._v("startlingly simple.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It seems to me that these definitions (actually, they’re more descriptions than definitions, but no matter—they get to the essence of it) give you a better feel for this elusive thing called an idea, for they talk about synthesis and problems and insights and obviousness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The one that I like the best, though, and the one that is the basis of this book, is this one from James Webb Young:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_vm._v("An idea is nothing more nor less"), _c('br'), _vm._v("than a new combination of old elements.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are two reasons I like it so much.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("First, it practically tells you how to get an idea for it says that getting an idea is like creating a recipe for a new dish. All you have to do is take some ingredients you already know about and combine them in a new way. It’s as simple as that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not only is it simple, it doesn’t take a genius to do "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("it. Nor does it take a rocket scientist or a Nobel Prize winner or a world-famous artist or a poet laureate or an advertising hotshot or a Pulitzer Prize winner or a first-class inventor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To my mind,” wrote the scientist and philosopher Jacob Bronowski, “it is a mistake to think of creative activity as something unusual.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ordinary people get good ideas everyday. Every day they create and invent and discover things. Every day they figure out different ways to repair cars and sinks and doors, to fix dinners, to increase sales, to save money, to teach their children, to reduce costs, to increase production, to write memos and proposals, to make things better or easier or cheaper—the list goes on and on.")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Second, I like it because it zeros in on what I believe is the key to getting ideas, namely, combining things. Indeed, everything I’ve ever read about ideas talks about combining or linkage or juxtaposition or synthesis or association.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("“It is obvious,” wrote Jacques Hadamard, “that invention or discovery, be it in mathematics or anywhere else, takes place by combining ideas. . . . The Latin verb "), _c('em', [_vm._v("cogito,")]), _vm._v(" for ‘to think,’ etymologically means ‘to shake together.’ St. Augustine had already noticed that and had observed that "), _c('em', [_vm._v("intelligo")]), _vm._v(" means ‘to select among.’”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("“When a poet’s mind is perfectly equipped for its work,” wrote T. S. Eliot, “it is constantly amalgamating disparate experiences. The ordinary man’s experience is chaotic, irregular, fragmentary. The latter falls in love or reads Spinoza, and these two experiences have nothing to do with each other, or with the noise of the typewriter or the smell of cooking; in the mind of the poet these experiences are always forming new wholes.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("“A man becomes creative,” wrote Bronowski, “whether he is an artist or a scientist, when he finds a new unity in the variety of nature. He does so by finding a likeness between things which were not thought alike before. … The creative mind is a mind that looks for unexpected likenesses.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Or listen to Robert Frost: “What is an idea? If you remember only one thing I’ve said, remember that an idea is a feat of association.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Or Francis H. Cartier: “There is only one way in which a person acquires a new idea: by the combination or association of two or more ideas he already has into a new juxtaposition in such a manner as to discover a relationship among them of which he was not previously aware.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("Nicholas Negroponte agrees: “Where do good new ideas come from? That’s simple—from differences. Creativity comes from unlikely juxtapositions.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("And Arthur Koestler wrote an entire book, "), _c('em', [_vm._v("The Act of Creation,")]), _vm._v(" based on “the thesis that creative originality does not mean creating or originating a system of ideas out of nothing but rather out of a combination of well-established patterns of thought—by a process of cross-fertilization.” Koestler calls this process “bisociation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The creative act,” he explained, “… uncovers, selects, reshuffles, combines, synthesizes already existing facts, ideas, faculties, skills.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("“Feats of association,” “unexpected likenesses,” “new wholes,” “shake together” then “select among,” “new (or unlikely) juxtapositions,” “bisociations” —however they phrase it, they’re all saying pretty much what James Webb Young said:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote1"
  }, [_vm._v("An idea is nothing more nor less"), _c('br'), _vm._v("than a new combination of old elements.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Now that we know what ideas are, we must devise a method for getting them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Happily enough, many such methods have already been devised. And—even more happily—these methods are quite similar.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("In "), _c('em', [_vm._v("A Technique for Producing Ideas,")]), _vm._v(" James Webb Young describes a five-step method for producing ideas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First, the mind must “gather its raw materials.” In advertising, these materials include “specific knowledge about products and people [and] general knowledge about life and events.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Second, the mind goes through a “process of masticating those materials.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Third, “You drop the whole subject and put the problem out of your mind as completely as you can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fourth, “Out of nowhere the idea will appear.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fifth, you “take your little newborn idea out into the world of reality” and see how it fares.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Hermann von Helmholtz, the German philosopher, said he used three steps to get new thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first was “Preparation,” the time during which he investigated the problem “in all directions” (Young’s second step).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The second was “Incubation,” when he didn’t think consciously about the problem at all (Young’s third step).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The third was “Illumination,” when “happy ideas come unexpectedly without effort, like an inspiration” (Young’s fourth step).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Moshe F. Rubinstein, a specialist in scientific problem solving at the University of California, says that there are four distinct stages to problem solving.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stage one: Preparation. You go over the elements "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("of the problem and study their relationships (Young’s first and second steps).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stage two: Incubation. Unless you’ve been able to solve the problem quickly, you sleep on it. You may be frustrated at this stage because you haven’t been able to find an answer and don’t see how you’re going to (Young’s third step).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stage three: Inspiration. You feel a spark of excitement as a solution, or a possible path to one, suddenly appears (Young’s fourth step).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stage four: Verification. You check the solution to see if it really works (Young’s fifth step).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("In "), _c('em', [_vm._v("Predator of the Universe: The Human Mind,")]), _vm._v(" Charles S. Wakefield says there “is a series of [five] mental stages that identify the creative act.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First, “is an awareness of the problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Second, “comes a defining of the problem.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Third, “comes a saturation in the problem and the factual data surrounding it” (Young’s first and second steps).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fourth, “comes the period of incubation and surface calm” (Young’s third step).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fifth, comes “the explosion—the mental insight, the sudden leap beyond logic, beyond the usual stepping-stones to normal solutions” (Young’s fourth step).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Ah, but even though they all generally agree on the steps you must take to get an idea, none of them talks "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("much about the condition you must be in to climb those steps. And if you’re not in condition, it doesn’t make any difference if you know the steps; you’ll never get the ideas that you’re capable of getting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For telling most people how to get an idea is a little like telling a first grader to find "), _c('em', [_vm._v("x")]), _vm._v(" when "), _c('em', [_vm._v("x")]), _vm._v("+ 9 = 2x + 4, or like telling a person with weak legs how to high jump. Just as you must know algebra before you can solve an equation, and just as you must have strong legs before you can high jump, so you must condition your mind before you can get an idea.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The first ten chapters make up "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part001"
    }
  }, [_vm._v("Part I")]), _vm._v(" of this book. They discuss "), _c('em', [_vm._v("Ten Ways to Idea-Condition Your Mind.")]), _vm._v(" You may read them in any order.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_vm._v("1. Have Fun")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_vm._v("2. Be More Like a Child")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_vm._v("3. Become Idea-Prone")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_vm._v("4. Visualize Success")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_vm._v("5. Rejoice in Failure")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_vm._v("6. Get More Inputs")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_vm._v("7. Screw Up Your Courage")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_vm._v("8. Team Up with Energy")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_vm._v("9. Rethink Your Thinking")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("10. Learn How to Combine")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("The last five chapters make up "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II")]), _vm._v(" of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They talk about "), _c('em', [_vm._v("A Five-Step Method for Producing Ideas")]), _vm._v(" that "), _c('em', [_vm._v("should")]), _vm._v(" be taken in sequence. Although I use different words, I too generally agree with Young. (Two exceptions: I add one step to his—the need to define the problem; and I combine his third and fourth steps because they seem one step to me, not two.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To some, my (and Young’s) last step may not seem part of the process of getting an idea, but it truly is, for an idea is not an idea until something happens with it.")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("11. Define the Problem")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("12. Gather the Information")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("13. Search for the Idea")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("14. Forget about It")]), _vm._v(" "), _c('p', {
    staticClass: "indenthanginga"
  }, [_vm._v("15. Put the Idea into Action")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ee3c7f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/introduction.vue
// module id = 81
// module chunks = 0